import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { ContextService} from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { RefDataService } from '../../services/context/ref-data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { UserService } from '../../services/context/user.service';
import { ChartDataService } from '../../services/context/chart-data.service';

import * as fromModel from '../../services/models';

@Component({
  selector: 'gp-context-debug',
  templateUrl: './context-debug.component.html',
  styleUrls: ['./context-debug.component.scss']
})
export class ContextDebugComponent implements OnInit, OnDestroy {

  appContext: string;
  appData: string;
  refData: string;
  uiState: string;
  chartData: string;
  userInfo: string;

  protected _storeAppContextSubscription: Subscription;
  protected _storeDataSubscription: Subscription;
  protected _refDataSubscription: Subscription;
  protected _uiStateSubscription: Subscription;
  protected _chartDataSubscription: Subscription;
  
  constructor(private contextService: ContextService,
    private dataService: DataService,
    private refDataService: RefDataService,
    private uiStateService: UIStateService,  
    private userService: UserService,
    private chartDataService: ChartDataService,
    private dialogRef: MatDialogRef<ContextDebugComponent>) { 
      this._storeAppContextSubscription = this.contextService.subscribe((appContext: fromModel.IAppContext) => this.populateAppContext(appContext));
      this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
      this._refDataSubscription = this.refDataService.subscribe((refData: fromModel.IRefData) => this.populateRefData(refData)); 
      this._uiStateSubscription =  this.uiStateService.subscribe((uiState: fromModel.IUIState) => this.populateUIContext(uiState));
      this._chartDataSubscription =  this.chartDataService.subscribe((chartData: fromModel.IChartData) => this.populateChartData(chartData));
  }

  ngOnInit() {
    this.userInfo = JSON.stringify(this.userService.getUser());
  }

  ngOnDestroy(): void{
    if(this._storeAppContextSubscription && this._storeAppContextSubscription !== null){
      this._storeAppContextSubscription.unsubscribe();
    }
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }   
    if(this._refDataSubscription && this._refDataSubscription !== null){
      this._refDataSubscription.unsubscribe();    
    } 
    if(this._uiStateSubscription && this._uiStateSubscription !== null){
      this._uiStateSubscription.unsubscribe();    
    }

    if(this._chartDataSubscription && this._chartDataSubscription !== null){
      this._chartDataSubscription.unsubscribe();    
    }
  }

  populateAppContext(appContext: fromModel.IAppContext){    
    this.appContext = JSON.stringify(appContext);
  }

  private populateAppData(appData: fromModel.IAppData){
    this.appData = JSON.stringify(appData);
  }

  private populateRefData(refData: fromModel.IRefData){
    this.refData = JSON.stringify(refData);
  }

  populateUIContext(uiState: fromModel.IUIState){     
    this.uiState = JSON.stringify(uiState);
  } 

  private populateChartData(chartData: fromModel.IChartData){
    this.chartData = JSON.stringify(chartData);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
